(() => {
  /*
   * Wambolt Shop System
   *
   * V1 preorder version is intentionally
   * presentation-only.
   *
   * Components are descriptive parts of one
   * complete Ready-to-Go System and therefore
   * have no individual product, price, link,
   * or variant behavior.
   *
   * This file remains in place so existing
   * theme script references do not need to be
   * changed.
   */

  if (
    window.wamboltShopSystemLoaded
  ) {
    return;
  }

  window.wamboltShopSystemLoaded =
    true;
})();